import { baseApi } from "./baseApi";

const DRIVER_DASHBOARD_BASE_URL = "/driver/dashboard";

export const driverDashboardApi = baseApi.injectEndpoints({
  tagTypes: ["DriverDashboard"],
  endpoints: (builder) => ({
    getDriverDashboardStats: builder.query({
      query: (driverId) => ({
        url: `${DRIVER_DASHBOARD_BASE_URL}/driverStats`,
        params: driverId ? { driverId } : {},
      }),
      providesTags: ["DriverDashboard"],
    }),
  }),
});

export const {
  useGetDriverDashboardStatsQuery,
} = driverDashboardApi;